import {useAddToCartOffCanvas} from "../redux/stateHooks";
import {CrossSellModel} from "../models/domain/crossSellModel";
import {CrossSellCarouselModel} from "../models/view/crossSellCarouselModel";
import * as React from "react";

const defaultModel = {models: undefined, carouselModel: undefined};

export const useAddToCartRecommendations = () => {
    const {product} = useAddToCartOffCanvas();

    const recommendations = (product?.recommendations ?? [] as CrossSellModel[])

    // If there are no recommended products, return the default model
    if (recommendations.length === 0) return defaultModel

    return recommendations.length === 0 ? defaultModel : {
        models: recommendations,
        carouselModel: new CrossSellCarouselModel(
            <div className="fs-3 ms-2 p-3">
                Users who bought this also bought
            </div>
        )
    }
};